/**
 * 클라이언트 설정
 *
 * resourceEndpoint는 부트스트랩에서 setResourceEndpoint()로 주입됩니다.
 *  - Electron: main/index.ts
 *  - React: App.tsx
 * 이 값(엔드포인트)가 설정되어있지 않으면 모든 리소스 요청이 실패합니다.
 */
class ClientConfig {
  //#region 싱글톤
  private static _instance: ClientConfig;

  private constructor() {
    this._token = '';
    this._resourceEndpoint = '';
  }

  public static get instance(): ClientConfig {
    if (!ClientConfig._instance) {
      ClientConfig._instance = new ClientConfig();
    }
    return ClientConfig._instance;
  }
  //#endregion

  private _token: string;
  private _resourceEndpoint: string;
  private _warnedMissingEndpoint = false;

  /**
   * Bearer 토큰 설정
   */
  public setToken(token: string): void {
    this._token = token;
  }

  /**
   * Bearer 토큰 반환
   */
  public getToken(): string {
    return this._token;
  }

  /**
   * Authorization 헤더 값 반환
   */
  public getAuthorizationHeader(): string {
    return this._token ? `Bearer ${this._token}` : '';
  }

  /**
   * Resource 서비스 엔드포인트 설정
   */
  public setResourceEndpoint(endpoint: string): void {
    if (!endpoint && process.env.NODE_ENV !== 'production') {
      console.warn(
        '[ClientConfig] setResourceEndpoint이 빈 값으로 호출되었습니다. ' +
          '환경변수(VITE_FILE_API_BASE_URL) 또는 APP_CONFIG/ENV 정의를 확인하세요.'
      );
    }
    this._resourceEndpoint = endpoint;
  }

  /**
   * Resource 서비스 엔드포인트 반환
   */
  public getResourceEndpoint(): string {
    if (
      !this._resourceEndpoint &&
      !this._warnedMissingEndpoint &&
      process.env.NODE_ENV !== 'production'
    ) {
      this._warnedMissingEndpoint = true;
      console.warn(
        '[ClientConfig] resourceEndpoint 미설정 상태로 사용되었습니다. ' +
          '초기 설정 시점에 setResourceEndpoint() 호출이 누락되었거나, ' +
          '주입 전에 R2ServiceClient 의 API가 호출되었을 수 있습니다.'
      );
    }
    return this._resourceEndpoint;
  }

  /**
   * 설정 초기화
   */
  public clear(): void {
    this._token = '';
  }
}

export { ClientConfig };
